module.exports = __webpack_public_path__ + "img/Luis.403cebea.jpg";